



























































































































































































































































































































import {
  SettingManagementCreateSettingRequest,
  ShowManagementSearchTitleDTO,
  ShowManagementService as showApi,
} from "@/common/api";
import { LANG } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import QInputMultipleLanguage from "@/components/common/qInputMultipleLanguage.vue";
import QLanguageBox from "@/components/common/qLanguageBox.vue";
import QLanguageTab from "@/components/common/qLanguageTab.vue";
import QReleaseSetting from "@/components/common/qReleaseSetting.vue";
import { SETTING, STATUS } from "@/model/releaseSetting";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ShowEditComponent",
  components: {
    QInputMultipleLanguage,
    QReleaseSetting,
    QLanguageTab,
    QLanguageBox,
    QErrors,
  },
  computed: {
    SettingManagementCreateSettingRequest() {
      return SettingManagementCreateSettingRequest;
    },
  },
})
export default class ShowEditComponent extends Vue {
  public title = "品評会の新規作成";
  public showId = null;
  public errors = {};
  public form: any = {
    title: "",
    title_en: null,
    title_cn: null,
    count: "",
    count_en: null,
    count_cn: null,
    note: "",
    note_en: null,
    note_cn: null,
    open_status: STATUS.EDIT,
    release_setting: null,
    post_date: null,
    items: [],
  };

  public item = {
    id: null,
    code: null,
    award: null,
    award_en: null,
    award_cn: null,
    award_group: null,
    award_group_en: null,
    award_group_cn: null,
    owner: null,
    owner_en: null,
    owner_cn: null,
    producer: null,
    producer_en: null,
    producer_cn: null,
    handled: null,
    handled_en: null,
    handled_cn: null,
    note: null,
    note_en: null,
    note_cn: null,
    show_id: null,
  };
  public originalForm: any = {};
  public languages = [LANG.EN, LANG.CN];
  public titles: ShowManagementSearchTitleDTO[] = [];

  get languagesObject() {
    return {
      cn: this.languages.includes(LANG.CN),
      en: this.languages.includes(LANG.EN),
      ja: true,
    };
  }

  get itemErrors() {
    let output = [];
    const filtered = Object.keys(this.errors).filter((key) =>
      key.startsWith("items."),
    );
    const itemErrors = {};
    for (const key of filtered) {
      itemErrors[key] = this.errors[key];
    }

    for (const value of Object.values(itemErrors)) {
      output.push(...(value as []));
    }

    output = output.filter((value, index) => {
      return output.indexOf(value) === index;
    });
    return {
      items: output,
    };
  }

  public async mounted() {
    this.showId = this.$router.currentRoute.params?.id;

    if (this.showId) {
      this.item.show_id = this.showId;
      await this.getDetail();
      this.title = `${this.form.title} の編集`;
    }
    if (this.form.items.length === 0) {
      this.form.items.push({ ...this.item });
    }

    if (!this.form.title_cn && !this.form.count_cn && !this.form.note_cn) {
      const index = this.languages.indexOf(LANG.CN);
      this.languages.splice(index, 1);
    }
    this.originalForm = JSON.parse(JSON.stringify(this.form));
    await this.getSearchParams();
  }

  public async getSearchParams() {
    const result = await showApi.adminShowListSearchParams({});
    this.titles = result.data.search_params.titles.map((item) => {
      return { id: item.id, name: item.name };
    });
  }

  public async getDetail() {
    const result = await showApi.adminShowShow({
      id: this.showId,
    });

    this.form = result.data.show;

    if (
      this.form.open_status === STATUS.RELEASE &&
      moment(this.form.post_date).isBefore(moment())
    ) {
      this.form.release_setting = SETTING.NOW;
      this.form.post_date = null;
    }

    if (this.form.post_date) {
      this.form.post_date = moment(this.form.post_date).format(
        "YYYY-MM-DD HH:mm",
      );
    }
  }

  public async submit() {
    let parameters: any = {};
    let result;
    try {
      parameters = {
        type: this.form.type,
        count: this.form.count,
        count_en: this.languages.includes("en") ? this.form.count_en : null,
        count_cn: this.languages.includes("cn") ? this.form.count_cn : null,
        note: this.form.note,
        note_en: this.languages.includes("en") ? this.form.note_en : null,
        note_cn: this.languages.includes("cn") ? this.form.note_cn : null,
        open_status: this.form.open_status,
        release_setting: this.form.release_setting,
        post_date: this.form.post_date,
        items: this.form.items,
      };

      result = this.showId
        ? await showApi.adminShowEdit({
          ...parameters,
          ...{ id: this.showId },
        })
        : await showApi.adminShowCreate(parameters);

      QNotify.success({
        text: this.showId
          ? this.$t("common.message.updated")
          : this.$t("common.message.created"),
      });
      this.$router.back();
    } catch (error: any) {
      result = error.body;
      QNotify.error({
        text: result.message,
      });
      this.errors = result.errors;
    }
  }

  public addItem() {
    this.form.items.push({ ...this.item });
  }

  public deleteItem(index) {
    this.form.items.splice(index, 1);
  }
  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let message: any;
        try {
          const response = await showApi.adminShowDelete({
            id: this.showId,
          });

          message = response.message;
          QNotify.success({
            text: message,
          });
          this.$router.back();
        } catch (error) {
          message = error.body.message;
          QNotify.error({
            text: message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public cancel() {
    // check modifier form.
    const diff = compareWithKeys(
      this.form,
      this.originalForm,
      [
        "title",
        "title_en",
        "title_cn",
        "count",
        "count_en",
        "count_cn",
        "note",
        "note_en",
        "note_cn",
        "open_status",
        "post_date",
        "release_setting",
        "items",
      ],
      true,
    );

    if (!diff) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        onConfirm: () => {
          this.$router.back();
        },
      });
    } else {
      this.$router.back();
    }
  }

  public async preview() {
    localStorage.setItem("show", JSON.stringify(this.form));
    const previewRoute = this.$router.resolve({ name: "admin.show.preview" });
    window.open(previewRoute.href, "_blank");
  }
}
